import { IconKeys } from '@axa-asia/emma-stylesheet/lib/components/EmmaAtoms/EmmaIcon';
import {
  MYPRIVILEGES_MODAL_DISPLAY,
  FETCH_MY_PRIVILEGES_FEATURES_SUCCESS,
  FETCH_MY_PRIVILEGES_FEATURES_FAILURE,
  SET_CTN_BUTTON_LOADING,
  SET_CTN_BUTTON_NOT_LOADING,
  MY_PRIVILEGES_SWITCH_CURRENT_TAB,
  COMPONENT_MOUNTED,
  SET_PAGE_LOADING,
  SET_PAGE_NOT_LOADING,
  UPDATE_DETAILS_PAGE_INFO,
} from '../../../modules/myPrivileges/actions/myPrivilegesAction';
import { LocalizedText } from '../../../types/LocalizedTextTypes';
import { EmmaAppWebViewDeepLink as DeepLink } from '../../../types/configTypes';

const currentTab = 'offers';
const defaultState = {
  isLoadingCtnButton: false,
  isLoadingPage: false,
  currentTab,
};

export interface CardViewState {
  myPrivilegesId?: string;
  myPrivilegesDetailsId?: string;
  title?: any;
  icon?: any;
  lockedIcon?: any;
  iconKey?: IconKeys;
  subtitle?: any;
  subjectDesc?: any;
  picture?: any;
  deepLink?: DeepLink;
  deepLinkLock?: DeepLink;
  myPrivilegesAuthToken?: MyPrivilegesAuthTokenConfig;
  privileges?: CardViewPrivilegesState;
  cardDeeplink?: string;
  subjectSubDesc?: any;
  cardFaceType?: string;
  cardImage?: string;
  isFetchingStage: boolean;
  isCustomerStateDisable?: boolean;
  windowSize?: number;
  hideBannerCaption: any;
  stageName: string;
  privilegesDetailsData: any;
}

export interface CardViewPrivilegesState {
  title?: string;
  icon?: string;
  subtitle?: string;
  subjectDesc?: string;
  supportDesc?: string;
  ctaBtnText?: string;
  openingHoursDisplay?: string;
  summaryTitle?: string;
  contactNumber?: string;
  summary?: string;
  more?: string;
  less?: string;
  banner?: CardViewPrivilegesBannersState[];
  section?: CardViewPrivilegesSectionsState[];
  stepSection?: CardViewPrivilegesStepSectionsState;
  stepSection2?: CardViewPrivilegesStepSectionsState;
  enquiry?: LocalizedText;
  enquiryDesc?: LocalizedText;
  tel?: LocalizedText;
  enquiryDesc2?: LocalizedText;
  tel2?: LocalizedText;
  enquiryDesc3?: LocalizedText;
  signalModel?: string;
  deepLink?: DeepLink;
  deepLinkLock?: DeepLink;
  termsCondition?: LocalizedText;
  termsConditionDesc?: LocalizedText;
  termsConditionTnc?: termsConditionTncState;
  termsConditionDesc2?: LocalizedText;
  termsConditionTnc2?: termsConditionTncState;
  termsConditionDesc3?: LocalizedText;
  morePrivileges?: LocalizedText;
  morePrivilegesTab?: string;
  morePrivilegesDesc?: LocalizedText;
  morePrivilegesBtnText?: LocalizedText;
  priceListTitle?: LocalizedText;
  priceListDesc?: LocalizedText;
  priceListLabel?: LocalizedText;
  priceListLink?: LocalizedText;
  isOffer?: boolean;
  isCtaEnabled?: boolean;
  image?: string;
  imageTitle?: string;
  imageDesc?: string;
  submittedForm?: string;
  alreadyEnrolled?: string;
  promotionEnded?: string;
}

export interface termsConditionTncState {
  tncId?: string;
  label?: LocalizedText;
}

export interface CardViewPrivilegesStepSectionsState {
  title?: LocalizedText;
  list?: CardViewPrivilegesStepItemsState[];
}

export interface CardViewPrivilegesStepItemsState {
  item?: LocalizedText;
  sub_item?: LocalizedText;
}

export interface CardViewPrivilegesBannersState {
  src?: string;
  smallViewportSrc?: string;
  caption?: any;
  videoUrl?: string;
  youtubeId?: string;
}

export interface CardViewPrivilegesServiceCardState {
  icon?: string;
  title?: string;
  desc?: string;
  buttonText?: string;
  deepLink?: any;
}

export interface CardViewPrivilegesSectionsState {
  title?: LocalizedText;
  desc?: LocalizedText;
  dropdownSection?: CardViewPrivilegesDropdownState;
}

export interface CardViewPrivilegesDropdownState {
  title?: LocalizedText;
  empty?: CardViewPrivilegessDropdownEmptyState;
  resultTitle?: LocalizedText;
  optionResults?: CardViewPrivilegesOptionResultsState[];
  option?: CardViewPrivilegesOptionsState[];
  optionPopups?: CardViewPrivilegesOptionPopupsState[];
}

export interface CardViewPrivilegesOptionsState {
  item?: LocalizedText;
  value?: LocalizedText;
}

export interface CardViewPrivilegesOptionResultsState {
  id?: string;
  icon?: LocalizedText;
  title?: LocalizedText;
  desc?: LocalizedText;
  value?: string[];
}

export interface CardViewPrivilegesOptionPopupsState {
  optionId?: string;
  icon?: LocalizedText;
  title?: LocalizedText;
  subtitle?: LocalizedText;
  banner?: LocalizedText;
  desc?: LocalizedText;
  btnText?: LocalizedText;
}

export interface CardViewPrivilegessDropdownEmptyState {
  tip?: LocalizedText;
  tipIcon?: LocalizedText;
  value?: string[];
}

export interface MyPrivilegesAuthTokenConfig {
  url: string;
  authTokenParamName: string;
}

export default (state: any = defaultState, action: any) => {
  const nextState = { ...state };
  switch (action.type) {
    case COMPONENT_MOUNTED:
      // nextState.currentTab = (window.location.hash === '#privileges') ? 'Privileges' : 'Offers';
      return nextState;
    case MYPRIVILEGES_MODAL_DISPLAY:
      nextState.isShowVhisModal = action.isShowVhisModal;
      nextState.selectedCardId = action.cardId;
      return nextState;
    case FETCH_MY_PRIVILEGES_FEATURES_SUCCESS:
      nextState.privilegeFeatures = action.featuresItems;
      return nextState;
    case FETCH_MY_PRIVILEGES_FEATURES_FAILURE:
      nextState.privilegeFeaturesError = action.error;
      return nextState;
    case SET_CTN_BUTTON_LOADING:
      nextState.isLoadingCtnButton = true;
      return nextState;
    case SET_CTN_BUTTON_NOT_LOADING:
      nextState.isLoadingCtnButton = false;
      return nextState;
    case SET_PAGE_LOADING:
      nextState.isLoadingPage = true;
      return nextState;
    case SET_PAGE_NOT_LOADING:
      nextState.isLoadingPage = false;
      return nextState;
    case MY_PRIVILEGES_SWITCH_CURRENT_TAB:
      nextState.currentTab = action.currentTab || currentTab;
      return nextState;
    case UPDATE_DETAILS_PAGE_INFO:
      nextState.detailsPageInfo = {
        ...(nextState.detailsPageInfo ?? {}),
        [action.payload.cardViewId]: action.payload.data
      }
      return nextState;
    default:
      return nextState;
  }
};
